import BaseApiService from '@/services/base-api.service';
import { API_BASE_URL } from '@/config/api';
import { Tag, TagCreate, TagUpdate, TagResponse } from '../types';

class TagService extends BaseApiService {
  constructor() {
    super(API_BASE_URL);
  }

  async getTags(params: { skip?: number; limit?: number } = {}): Promise<TagResponse> {
    const queryParams = new URLSearchParams();
    
    if (typeof params.skip === 'number') {
      queryParams.append('skip', params.skip.toString());
    }
    
    if (typeof params.limit === 'number') {
      queryParams.append('limit', params.limit.toString());
    }

    const response = await this.get<TagResponse>('/tags/', { params: queryParams });
    return response.data;
  }

  async getTag(id: number): Promise<Tag> {
    const response = await this.get<Tag>(`/tags/${id}`);
    return response.data;
  }

  async createTag(data: TagCreate): Promise<Tag> {
    const response = await this.post<Tag>('/tags/', data);
    return response.data;
  }

  async updateTag(id: number, data: TagUpdate): Promise<Tag> {
    const response = await this.put<Tag>(`/tags/${id}`, data);
    return response.data;
  }

  async deleteTag(id: number): Promise<void> {
    await this.delete(`/tags/${id}`);
  }

  async toggleFavorite(id: number): Promise<Tag> {
    const tag = await this.getTag(id);
    const response = await this.put<Tag>(`/tags/${id}`, {
      is_favorite: !tag.is_favorite
    });
    return response.data;
  }
}

export const tagService = new TagService(); 